import { useEffect } from 'react';
import routes from '../../../routes';
import client from '../../../utils/client';
import { getAuthToken } from '../../../utils/authToken';

export const AUTH_SESSION_CHANNEL = 'spotlight-auth-session';
export const AUTH_STATUS_REQUEST = 'spotlight:auth-status-request';
export const AUTH_STATUS_RESPONSE = 'spotlight:auth-status-response';

const validateCurrentSession = async () => {
  const token = getAuthToken();
  if (!token) return false;

  try {
    await client(false, { headers: { authorization: token } }).get('/users/me');
    return true;
  } catch (error) {
    return false;
  }
};

const AuthSessionResponder = () => {
  useEffect(() => {
    if (
      typeof window === 'undefined'
      || !window.BroadcastChannel
      || window.location.pathname === routes.sessionStatus
    ) {
      return undefined;
    }

    const channel = new window.BroadcastChannel(AUTH_SESSION_CHANNEL);
    let active = true;

    const handleMessage = async (event) => {
      if (event?.data?.type !== AUTH_STATUS_REQUEST || !event.data.requestId) return;

      const authenticated = await validateCurrentSession();
      if (!active) return;

      channel.postMessage({
        type: AUTH_STATUS_RESPONSE,
        requestId: event.data.requestId,
        authenticated,
      });
    };

    channel.addEventListener('message', handleMessage);

    return () => {
      active = false;
      channel.removeEventListener('message', handleMessage);
      channel.close();
    };
  }, []);

  return null;
};

export default AuthSessionResponder;
